import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

export const MainLayout = ({ children, transparentHeader = false }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--ns-bg)] text-[var(--ns-text)]">
      <Header transparent={transparentHeader} />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};
